<script lang="ts">
    import CN from "classnames";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Spinner from "@components/Spinner/Spinner.svelte";

    //Optional Props
    export let className: string;
    export { className as class };

    export let variant: "primary" | "secondary" | "link" = "primary";
    export let fullWidth = false;
    export let role: string | null = null;
    export let ariaLabel: string | null = null;
    export let ariaControls: string | null = null;
    export let ariaSelected: boolean | null = null;
    export let type: "button" | "submit" | "reset" = "button";
    export let disabled = false;
    export let isLoading = false;

    //Reactive Statement
    $: classes = CN(
        "gw-rd-action-btn",
        `gw-rd-action-btn--${variant}`,
        className,
        {
            "gw-rd-action-btn--full-width": fullWidth,
            "gw-rd-action-btn--disabled": disabled || isLoading,
            "gw-rd-action-btn--loading": isLoading,
        }
    );
</script>

<BaseButton
    on:click
    class={classes}
    {role}
    {ariaLabel}
    {ariaControls}
    {ariaSelected}
    {type}
>
    <span class="gw-rd-action-btn__spinner">
        <Spinner size="20px" color={"var(--gw-rd-white-color)"} />
    </span>
    <slot />
</BaseButton>

<style lang="postcss" global>
    @define-mixin primary {
        border: 1px solid var(--gw-rd-primary-button__theme-color);
        color: var(--gw-rd-buttons__font-color);
        background-color: var(--gw-rd-primary-button__theme-color);
    }

    @define-mixin secondary {
        border: 1px solid var(--gw-rd-secondary-button__theme-color);
        color: var(--gw-rd-primary-color);
        background-color: transparent;
    }

    @define-mixin hover $color {
        @media (hover: hover) {
            &:hover {
                background-color: $color;
            }
        }
    }

    .gw-btn.gw-rd-action-btn {
        position: relative;
        padding: var(--gw-rd-space-4) var(--gw-rd-space-7);
        opacity: 1;
        border-radius: var(--gw-rd-border-radius-xs);
        font-size: 12px;
        font-family: inherit;
        transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out,
            opacity 0.1s ease-in-out;

        &--primary {
            @mixin primary;
            @mixin hover var(--gw-rd-primary-button__theme-highlight-color);
        }

        &--secondary {
            @mixin secondary;
            @mixin hover var(--gw-rd-secondary-button__theme-highlight-color);
        }

        &--link {
            height: auto;
            padding: 0;
            border: none;
            color: var(--gw-rd-primary-color);
            background-color: transparent;
        }

        &--full-width {
            width: 100%;
        }

        &--disabled {
            opacity: 0.4;
            pointer-events: none;
            user-select: none;
            color: var(--gw-rd-white-color);
            background-color: hsla(221, 4%, 68%, 1);
            border-color: hsla(221, 4%, 68%, 1);

            @mixin hover hsla(221, 4%, 68%, 1);
        }

        &--loading.gw-rd-action-btn,
        &--loading :global(.gw-layout-text.gw-layout-text--variant-button) {
            color: transparent;

            .gw-rd-action-btn__spinner {
                display: block;
            }
        }

        .gw-rd-action-btn__spinner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -40%);
            display: none;
        }
    }
</style>
